import { render } from "./AddDocumentTypeFobPopUpNew.vue?vue&type=template&id=3292aeb4&scoped=true"
import script from "./AddDocumentTypeFobPopUpNew.vue?vue&type=script&lang=js"
export * from "./AddDocumentTypeFobPopUpNew.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AddDocumentTypeFobPopUpNew.vue?vue&type=style&index=1&id=3292aeb4&scoped=true&lang=css"
import "./AddDocumentTypeFobPopUpNew.vue?vue&type=style&index=2&id=3292aeb4&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3292aeb4"]])

export default __exports__